import {
  AccountCircle as ProfileIcon,
  History as SessionsIcon,
} from '@mui/icons-material';

export const ACCOUNT_TABS = [
  { id: 'profile', label: 'Profile', icon: ProfileIcon },
  { id: 'sessions', label: 'My Sessions', icon: SessionsIcon },
];

export const getAccountTabPath = (tabId) => {
  const normalizedTabId = String(tabId || '').trim().toLowerCase();
  const match = ACCOUNT_TABS.find((tab) => tab.id === normalizedTabId);
  const resolvedTabId = match?.id || 'profile';

  if (resolvedTabId === 'profile') {
    return '/account';
  }

  return `/account?tab=${encodeURIComponent(resolvedTabId)}`;
};
